































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class JdiStatus extends Vue {
    @Prop() living!: boolean;
    @Prop() proposal!: boolean;
    @Prop() wip!: boolean;

    @Prop() rc!: boolean;
}
